export const imgDefaultH: string =
	'https://nstatic.jtbc.co.kr/news-front/images/default-image-horizontal.png'
export const imgDefaultV: string =
	'https://nstatic.jtbc.co.kr/news-front/images/default-image-vertical.png'
